import * as React from 'react';

/** @deprecated Work with your designer to replace with one of the current illustrations (https://lens.loom.dev/illustrations/illustration-set). */
function IllustrationUpgrade(props) {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100 100H0V0h100v100zM67.146 64.937L89.837 90H10.163l22.691-25.063H10.163L36.04 46.705H10.163L38.196 33.03H10.163l25.895-9.357H10.163l23.902-6.477H10.163L50 10l39.837 7.197H65.935l23.902 6.477H63.942l25.895 9.357H61.804l28.033 13.674H63.96l25.877 18.232H67.146z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IllustrationUpgrade;
